<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-yellow">
      <div class="card-icon">
        <md-icon>receipt</md-icon>
      </div>
      <h4 class="title">{{ $t('pages.dashboard.myorders') }}</h4>
    </md-card-header>
    <md-card-content>
      <div v-if="!myOrders.length" class="spinner-wrapper">
        <div v-if="isRunning">
          <md-progress-spinner class="md-accent" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div v-if="!isRunning">
          Du har ingen ordrer i systemet.
        </div>

      </div>
      <md-table v-model="myOrders"
                table-header-color="green"
                md-sort="name"
                md-sort-order="desc">
        
        
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="OrderId">{{ item.mys_extordernumber }}</md-table-cell>
          <md-table-cell md-label="Date" md-sort-by="mys_date">{{ m(item.mys_date).format('ll') }}
          </md-table-cell>

          <md-table-cell>
            <a v-bind:href="item.galleryUrl" target="_blank">
              <md-button class="md-icon-button md-success">
                <md-icon>picture_in_picture</md-icon>
                <md-tooltip md-direction="top">Gallery</md-tooltip>
              </md-button>
            </a>

          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
  </md-card>
</template>

<script>
import apiService from '../../../services/APIService';
import moment from 'moment'
import {mapGetters} from 'vuex';

moment.locale('da-DK');

export default {
  components: {},
  data() {
    return {
      isRunning: false,
      m: moment,
      myOrders: []
    };
  },
  computed: {
    ...mapGetters(["activeAccount"])
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isRunning = true;
      apiService.getApi(`/portals/v1/user/orders`)
          .then(response => {
            this.isRunning = false;
            this.myOrders = response.data;
          })
          .catch(() => this.isRunning = false);
    }
  }
};
</script>
